import Validate from 'validate.js'
import dayjs from 'dayjs'

Validate.validators.datetime = (value, options) => {
  return dayjs(value).isValid() ? undefined : options.message
}
